import * as React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250
		}
	}
};

// let names = [];

function getStyles(name, focusSeriesName, theme) {
	return {
		fontWeight: focusSeriesName.includes(name)
			? theme.typography.fontWeightMedium
			: theme.typography.fontWeightRegular
	};
}

function SeriesDropDown({ seriesAPIData, getFocusSeries, theFocusSeries }) {
	const [focusSeriesName, setFocusSeriesName] = React.useState(theFocusSeries);

	const handleChange = (event) => {
		console.log(event.target);
		//send event.target.value to app.js
		getFocusSeries(event.target.value);

		const {
			target: { value }
		} = event;
		setFocusSeriesName(
			// On autofill we get a stringified value.
			typeof value === "string" ? value.split(",") : value
		);
	};

	return (
		<div>
			<FormControl sx={{ m: 1, width: 300 }}>
				<InputLabel id="demo-multiple-checkbox-label">Series</InputLabel>
				<Select
					labelId="demo-multiple-checkbox-label"
					id="demo-multiple-checkbox"
					value={focusSeriesName ? focusSeriesName : ""}
					onChange={handleChange}
					input={<OutlinedInput label="Series" />}
					renderValue={(selected) => selected}
					MenuProps={MenuProps}
				>
					{seriesAPIData.map((name) => (
						<MenuItem key={name.seriesname} value={name.seriesname}>
							<Checkbox checked={focusSeriesName === name.seriesname} />

							<ListItemText primary={name.seriesname} />
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</div>
	);
}
export default SeriesDropDown;
